export default __webpack_public_path__ + "media/color/sbd-f3c75d39.svg";